import './index.css';
import { useEffect, useState } from 'react';
import Iframe from 'react-iframe';
import { useRouteLocation } from 'react-router-stack';
import { View, Text } from '../../../component';
import { Dots } from 'react-activity';
import 'react-activity/dist/Dots.css';
import useTheme from '../../../utilities/hooks/theme';
import DefaultContainer from '../../default_container';
const IframePage = () => {
  const { MoreTheme: theme } = useTheme();
  const { state = {} } = useRouteLocation();
  const [loading, setLoading] = useState(false);
  const { url = '' } = state;

  useEffect(() => {
    setTimeout(() => {
      setLoading(true);
    }, 100);
  }, []);

  const iframeLoaderMessage = {
    color: theme.iframeLoaderMessage
  };
  const dimension = loading ? '100%' : '0px';
  return (
    <DefaultContainer>
      <View className={'iframe-page-container'}>
        {!loading && (
          <View className={'iframe-page-loading-container'}>
            <Dots size={25} color={theme.iframeLoader} />
            <Text style={iframeLoaderMessage} className={'iframe-page-loading-message'}>
              {'Loading Page ...'}
            </Text>
          </View>
        )}
        <Iframe
          url={url}
          className={loading ? 'iframe-page-container' : ''}
          width={dimension}
          height={dimension}
          position="relative"
        />
      </View>
    </DefaultContainer>
  );
};
export default IframePage;
